import { PercentPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lsqPercent'
})
export class LsqPercentPipe implements PipeTransform {
    private readonly _defaultDigitInfo = '1.0-1';

    constructor(private _percentPipe: PercentPipe) {}

    public transform(
        value: string | number,
        digitInfo = this._defaultDigitInfo,
        fromDecimal = false
    ): string {
        const upperLimit = fromDecimal ? 1 : 100;

        if (typeof (0 + (value as string)) === 'number' && !window.isNaN(value as number)) {
            const numberValue = +value;
            if (numberValue <= upperLimit) {
                return this._percentPipe.transform(numberValue / upperLimit, digitInfo);
            } else {
                return '100%+';
            }
        } else {
            return this._percentPipe.transform(0, digitInfo);
        }
    }
}
